module.exports = __webpack_public_path__ + "img/logo.94424145.png";